import React from 'react';
import {
  formatUrlAddress,
  formatUnitNumber,
  formatBathrooms,
  getListingPhoto,
} from '../../../lib/helpers';
import NumberElement from '../NumberElement';
import styles from '../../../styles/sass/pages/Search.module.scss';
import { useRouter } from 'next/router';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { fetchListingById } from '../../../actions/listing';

interface Props {
  overlayListings: any;
  dispatch: any;
}

export function MarkerOverlayContent(props: Props) {
  const { overlayListings, dispatch } = props;
  const renderContent = (listing: any) => {
    const router = useRouter();
    return (
      <div
        id="overlay-component"
        className={styles.markerOverlayContent}
        key={listing.id}
        onClick={(e: any) => {
          const filters = JSON.parse(get(router, 'query.filters', '{}'));
          const photosByRoom = get(filters, 'photosByRoom', undefined);
          if (e.metaKey || e.ctrlKey || e.altKey) {
            window.open(
              `/listing/r/${listing.id}/${formatUrlAddress(listing)}${
                photosByRoom ? `?photosByRoom=${photosByRoom}` : ''
              }`,
            );
            return;
          }

          dispatch(
            fetchListingById(listing.listingMlsId, true, photosByRoom, true),
          );
        }}
      >
        <div id="overlay-component" className={styles.overlayContainer}>
          <div id="overlay-component" className={styles.imageContainer}>
            <img
              alt="Property Image"
              className={styles.propertyImage}
              height="100%"
              id="overlay-component"
              src={getListingPhoto(listing, 'small')}
              width="100%"
            />
          </div>
          <div id="overlay-component" className={styles.infoContainer}>
            <p className={styles.priceTag} id="overlay-component">
              <NumberElement val={listing.listPrice} prefix="$" />
            </p>
            <p className={styles.addressTag} id="overlay-component">
              {listing.streetNo} {listing.streetName}
              {listing.unitNo ? ` ${formatUnitNumber(listing.unitNo)}` : ''}
            </p>
            <p className={styles.detailsTag} id="overlay-component">
              {listing.noBedrooms}br
              <span className="listing-pipe"> | </span>
              {formatBathrooms(listing)}ba
              <span className="listing-pipe"> | </span>
              {listing.squareFeet ? (
                <NumberElement val={listing.squareFeet} decimalScale={0} />
              ) : (
                '--'
              )}
              sf
            </p>
          </div>
        </div>
      </div>
    );
  };
  return (
    <React.Fragment>
      {overlayListings.map((overlayListing: any, index: number) => {
        return (
          <React.Fragment key={index}>
            {renderContent(overlayListing)}
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
}
const mapDispatchToProps = (dispatch: any) => ({
  dispatch,
});

export default connect(null, mapDispatchToProps)(MarkerOverlayContent);
